"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.queryExpensiveRule = void 0;
const utils_1 = require("@azimutt/utils");
const databaseUtils_1 = require("../../databaseUtils");
const duration_1 = require("../../helpers/duration");
const sql_1 = require("../../helpers/sql");
const connector_1 = require("../../interfaces/connector");
const rule_1 = require("../rule");
const ruleId = 'query-expensive';
const ruleName = 'expensive query';
const ruleDescription = 'top 20 queries by total execution time';
const CustomRuleConf = rule_1.RuleConf.extend({
    ignores: connector_1.QueryId.array().optional(),
}).strict().describe('QueryExpensiveConf');
exports.queryExpensiveRule = {
    id: ruleId,
    name: ruleName,
    description: ruleDescription,
    conf: { level: rule_1.RuleLevel.enum.hint },
    zConf: CustomRuleConf,
    analyze(conf, now, db, queries, history, reference) {
        const refIgnores = reference.map(r => r.extra?.queryId).filter(utils_1.isNotUndefined);
        const ignores = refIgnores.concat(conf.ignores || []);
        return queries
            .filter(q => !ignores.some(i => i === q.id))
            .sort((a, b) => -((a.exec?.sumTime || 0) - (b.exec?.sumTime || 0)))
            .slice(0, 20)
            .map(q => {
            const entity = (0, sql_1.getMainEntity)(q.query);
            const { id, database, query, ...stats } = q;
            return (0, utils_1.removeUndefined)({
                ruleId,
                ruleName,
                ruleLevel: conf.level,
                message: `Query ${q.id}${entity ? ` on ${(0, databaseUtils_1.entityRefToId)(entity)}` : ''} is one of the most expensive, cumulated ${(0, duration_1.showDuration)(q.exec?.sumTime || 0)} exec time in ${(0, utils_1.pluralize)(q.exec?.count || 0, 'execution')} (${(0, sql_1.formatSql)(q.query)})`,
                entity,
                extra: { queryId: id, query, stats, entities: (0, sql_1.getEntities)(q.query) }
            });
        });
    }
};
//# sourceMappingURL=queryExpensive.js.map